module.exports = __webpack_public_path__ + "static/img/RW.93766250.svg";